export const positionClassNames = {
    center: "modal-overlay--center",
    right: "modal-overlay--right",
};
